/* Qarshaa - Oct 19 2026: the pre-checkout address popup was removed so customers go straight to Shopify checkout
   (national short address is optional there). The original popup is kept in theme "qarshaa-theme – بدون STC Pay v18". */
(function () {
  'use strict';
  window.qaOpenAddressStep = function (href) {
    var EN = /^\/en(\/|$)/.test((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    window.location.href = (href && /\/checkout/.test(href)) ? href : (EN ? '/en/checkout' : '/checkout');
  };
})();
